import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AccountModule } from '../account/account.module';
import { CoreRoutingModule } from './core-routing.module';
import { DeletedAccountComponent } from './deleted-account/deleted-account.component';
import { HealthComponent } from './health/health.component';
import { HttpClientModule } from '@angular/common/http';
import { NotFoundComponent } from './not-found/not-found.component';
import { PasswordRequestComponent } from './password-request/password-request.component';
import { PatientsModule } from '../patients/patients.module';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { SharedModule } from '../shared/shared.module';
import { SignInComponent } from './sign-in/sign-in.component';

@NgModule({
  declarations: [
    SignInComponent,
    NotFoundComponent,
    PasswordRequestComponent,
    ResetPasswordComponent,
    DeletedAccountComponent,
    HealthComponent,
  ],
  imports: [
    CommonModule,
    CoreRoutingModule,
    HttpClientModule,
    AccountModule,
    PatientsModule,
    SharedModule,
  ],
  exports: [SharedModule],
})
export class CoreModule {}
